const ANIMATING = "animating";
const EXPANDED = "is-expanded";
const DURATION = 425;

$(".accordion-item__header").on("click", function () {
    $(this).children("i").toggleClass("dn");
});

$(document).on("ready", function (element) {
    const menu = document.getElementById("menu");
    const button = document.getElementById("menu-toggle");
    const menuItemsList = document.querySelector(".main-menu__body");
    let onlyVisibleElementsList = [];

    for (let item of menuItemsList.children) {
        if (!item.classList.value.includes("hidden")) {
            onlyVisibleElementsList.push(item);
        }
    }
    var lastItem = onlyVisibleElementsList[onlyVisibleElementsList.length -1];
    lastItem.firstChild.id = "main-menu_last_link";

    $(document).keydown(function (e) {
        // Moves the focus to the menu-button on escape-button input
        if (e.key === "Escape" && menu.classList.contains(EXPANDED)) {
            button.click();
        }
        // Moves focus to menu button after last menu-item has been focues on with tab
        if (e.key === "Tab" && menu.classList.contains(EXPANDED)) {
            if(button === document.activeElement && e.shiftKey) {
                e.preventDefault();
                const lastLink = document.getElementById("main-menu_last_link");
                lastLink.focus();
            }
            if (document.activeElement.parentElement == onlyVisibleElementsList[onlyVisibleElementsList.length - 1] && !e.shiftKey) {
                e.preventDefault();
                button.focus();
            }
        }
    });
});

const getComputedTranslateY = (el) => {
    const transform = window.getComputedStyle(el).getPropertyValue("transform");
    const matrix = transform.match(/([-+]?[\d.]+)/g);

    return matrix ? parseFloat(matrix[5]) : 0;
};

const cleanupAfterAnimation = (...elms) =>
    elms.forEach((el) => {
        el.classList.remove(ANIMATING);
        el.removeAttribute("style");
    });

function mainNavButton(el, isExpanded = false) {
    const textEl = el.querySelector("span.menu-text");
    const iconEl = el.querySelector(".menu-content i.icon-arrow-down-light");
    const toggleText = toggleAttr(textEl, "textContent", textEl.getAttribute("data-expanded-text"));
    const toggleIcon = toggleAttr(iconEl, "class", "icon icon-close-light");
    const toggleButton = (state) => {
        toggleIcon(state);
        toggleText(state);
    };

    if (isExpanded) toggleButton(true);

    return toggleButton;
}

function mainNav() {
    const header = document.querySelector(".header");
    const content = document.querySelector("#content.container");
    const button = document.getElementById("menu-toggle");
    const menu = document.getElementById("menu");
    const toggleNav = toggle("menu", header);
    const toggleButton = mainNavButton(button, toggleNav.visible);

    toggleNav.on("expand", () => {
        toggleButton(true);
        menu.classList.add(EXPANDED, ANIMATING);

        anime({
            targets: content,
            opacity: [1, 0],
            duration: DURATION,
            easing: "easeOutQuint",
        });

        anime({
            targets: [menu],
            translateY: (el) => [getComputedTranslateY(el), 0],
            easing: "easeOutQuint",
            duration: DURATION,
            complete: () => cleanupAfterAnimation(menu, content),
        });

        menu.setAttribute("tabindex", 0);
        menu.focus();
    });

    toggleNav.on("collapse", () => {
        toggleButton(false);
        menu.classList.add(ANIMATING);
        menu.classList.remove(EXPANDED);
        menu.removeAttribute("tabindex");

        anime({
            targets: content,
            opacity: [0, 1],
            duration: DURATION,
            easing: "easeInQuint",
        });

        anime({
            targets: [menu],
            translateY: (el) => [getComputedTranslateY(el), el === menu ? -200 : 200],
            easing: "easeInQuint",
            duration: DURATION,
            complete: () => cleanupAfterAnimation(menu, content),
        });
    });
}
